export default {
  feedback: {
    success: 'Aplicação móvel guardada com sucesso',
    error: 'Falha ao guardar a aplicação móvel',
  },
};
